import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import Button from '../Button';
import LinkIcon from '@/icons/link.svg?react';
import TaxLogo from '@/icons/tax-powered-by-countx.svg?react';

const LEARN_MORE_URL = 'https://www.jtl-software.com/de/countx-wird-tax/';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
}

export default function IntroBannerModal({ isModalOpened, closeModal }: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      closeOnClickOutside={false}
      title={t('Important update')}
      name='IntroBanner'
    >
      <div className='flex flex-col gap-4 px-8 pb-8 pt-4'>
        <div
          className='relative flex h-[200px] w-full items-center justify-center rounded-2xl bg-[#2722F8]'
          data-testid='IntroBanner-hero'
        >
          <TaxLogo className='absolute right-6 top-4 h-8 w-auto' />
          <p className='whitespace-pre-line text-center text-[32px] font-extrabold leading-10 text-white'>
            {t('Welcome\nto the new design')}
          </p>
        </div>
        <h4 className='whitespace-pre-line text-h4 font-extrabold text-dark'>
          {t(
            'countX is now part of the JTL brand. Your VAT solution is called Tax powered by countX from today.'
          )}
        </h4>
        <div className='text-dark'>
          <p>{t('For you, everything stays as it was:')}</p>
          <ul>
            <li>• {t('Same login and same credentials')}</li>
            <li>• {t('Same contract and same pricing')}</li>
            <li>• {t('Same personal VAT expert')}</li>
            <li>• {t('Same process for uploads, deadlines and filings')}</li>
          </ul>
        </div>
        <p className='text-dark'>
          {t(
            'Your filings in progress are not affected. You do not need to do anything.'
          )}
        </p>
        <a
          className='group flex w-fit items-center font-semibold text-blue-500'
          target='_blank'
          rel='noopener noreferrer'
          href={LEARN_MORE_URL}
          data-testid='IntroBanner-learn-more'
        >
          {t('Learn more')}
          <LinkIcon className='ml-1 inline-block [&>*]:fill-blue-500' />
        </a>
        <div>
          <Button onClick={closeModal} data-testid='IntroBanner-got-it'>
            {t('Got it')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
